// export const API_BASE_URL = "https://backend.etguesthome.com";
// export const API_BASE_URL = "http://188.245.70.180:9010";
// export const API_BASE_URL = "https://api.etguesthome.com";
// export const API_BASE_URL = "https://dev.etguesthome.com";
export const API_BASE_URL = "https://ghdev.etguesthome.com";

// Refresh endpoint — tweak this if your backend exposes refresh at a different path.
// Default follows SimpleJWT with the same `/auth/api/v1/` prefix used by signin.
export const REFRESH_TOKEN_ENDPOINT = "/auth/api/v1/token/refresh/";